import React, { useEffect } from 'react'
import css from './ListAdmin.module.scss'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { Controller } from 'react-hook-form'
import { doDeleteAdmin, doSaveAdmin, doUpdateAdmin } from '../../../Services/Admin/AuthAdminSevices'
import { useNavigate, useParams } from 'react-router-dom'
import { getDataAdminByUsername, getDataListAdmin } from '../../../Services/Admin/ListAdminServices'

const EditUserAdminPage = () => {
    const navigate = useNavigate();
    const { username } = useParams();
    const [isDeletedPopup, setisDeletedPopup] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const [isSuccessDeleted, setIsSuccessDeleted] = useState(false);
    const {control, register, handleSubmit, setValue, watch, formState: { errors }, reset} = useForm();
    const [buttonClicked, setButtonClicked] = useState('');
    const [dataUser, setDataUser] = useState({});

    const hideModal = () => {
        setisDeletedPopup(false)
        setIsSuccess(false)  
    };

    const handleDeleteConfirm = () => {
        
        doDeleteAdmin(dataUser).then((result) => {
            setIsSuccessDeleted(true)
        }).catch(({ response }) => {
            console.log(response)
        });
        
        // hideModal();
    };
    
    function GetDataUser(){
        getDataAdminByUsername(atob(username)).then((result) => {
            setDataUser(result.data.data[0]._id)
            setValue('username', result.data.data[0].username)
            setValue('email', result.data.data[0].email)
            setValue('is_active', result.data.data[0].is_active)
        }).catch(({ response }) => {
            if(response.status === 401){
                console.log(response)
            }
        });
    }

    function onUpdate(data) {
        if(buttonClicked == 'save'){
            doUpdateAdmin(data, dataUser).then((result) => {
                console.log(result)
                setIsSuccess(true)
            }).catch(({ response }) => {
                console.log(response)
            });
        }else if(buttonClicked == 'delete'){
            setisDeletedPopup(true)
        }
    }

    useEffect(() => {
        GetDataUser()
    }, [])
    
    return (
    <div className='wrap_admin'>
        {isDeletedPopup && 
            <div className={css.popup_wrap} onClick={hideModal}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={hideModal}></i>
                    <img src="/monitoring/assets/delete.png" />
                    <b>Delete Confirmation</b>
                    <p>You are about to delete this station, are you sure?</p>
                    <button onClick={hideModal} className='admin-button cancel'>No</button>
                    <button onClick={handleDeleteConfirm} className='admin-button delete'>Yes</button>
                </div> 
            </div>
        }
        
        {isSuccess && 
            <div className={css.popup_wrap} onClick={hideModal}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={hideModal}></i>
                    <img src="/monitoring/assets/success.png" />
                    <b>Successful!</b>
                    <p>The Data has just been updated. </p>
                </div> 
            </div>
        }
        
        {isSuccessDeleted && 
            <div className={css.popup_wrap} onClick={()=>navigate(-1)}>
                <div className={css.content_popup}>          
                    <i class="fi fi-rr-cross-small" onClick={()=>navigate(-1)}></i>
                    <img src="/monitoring/assets/success.png" />
                    <b>Successful!</b>
                    <p>The Data has just been deleted. </p>
                </div> 
            </div>
        }
        <div className='row vh-100'>
            <div className='col-md-12' style={{ maxHeight: '100vh', overflowY: 'auto', overflowX: 'hidden' }}>
                <div className={`${css.content_position} row`} style={{ marginBottom: 100 }}>
                    <form className={`${css.form}`} onSubmit={handleSubmit(onUpdate)}>
                        <label>Username</label>
                        <input type='text' placeholder='Add Username'     
                            {...register("username", { 
                                required: "This field is required",
                                pattern: {
                                    value: /^[a-zA-Z0-9-_.@]+$/,
                                    message: "Username must be alphanumeric and can only include -, ., @"
                                }
                            })}
                        />
                        {errors.username && <p style={{color:'red'}}>{errors.username.message}</p>}

                        <label>Email</label>
                        <input type='text' placeholder='Add Email' 
                            {...register("email", {
                                required: "Email is required",
                                pattern: {
                                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                  message: "Invalid email address"
                                }
                            })} 
                            value={dataUser.email}
                        />
                        
                        <input type='hidden' value={'user'}
                            {...register("role")}  
                        />

                        {errors.email && <p style={{color:'red'}}>This field is required</p>}

                        <Controller
                            name="is_active"
                            control={control}
                            render={({ field: { onChange, value } }) => (
                                <>
                                    <label>Status</label>
                                    <input
                                        type='radio'
                                        value={1}
                                        checked={value === true}
                                        onChange={() => onChange(true)}
                                    /> Active
                                    <input
                                        type='radio'
                                        value={0}
                                        checked={value === false}
                                        onChange={() => onChange(false)}
                                        style={{marginLeft:15}}
                                    /> Unactive
                                </>
                            )}
                        />
                        {errors.is_active && <p style={{color:'red'}}>This field is required</p>}

                        <div className='row' style={{marginTop:40, marginLeft:-15}}>
                            <div className='col-md-8'>
                                <button className='admin-button delete' onClick={() => setButtonClicked('delete')}>Delete</button>
                            </div>
                            <div className='col-md-4' style={{float:'right'}}>
                                <button className='admin-button cancel' onClick={() => navigate(-1)} style={{marginRight:10}}>Cancel</button>
                                <button className='admin-button save' onClick={() => setButtonClicked('save')}>Save</button>  
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
  )
}

export default EditUserAdminPage